module.exports = __webpack_public_path__ + "img/food.9e9e4644.svg";